import {
  DataWrapper,
  Section,
  SectionContent,
  SectionContentScroll,
  SectionTitle,
} from "components/base/DataScreenBase";
import OnlinePlayerDetails from "./OnlinePlayerDetails";
import ScreenChat from "./ScreenChat";

export default function Comms() {
  return (
    <DataWrapper>
      <Section>
        <SectionTitle>Tranmissions</SectionTitle>
        <SectionContent>
          <ScreenChat />
        </SectionContent>
      </Section>
      <Section>
        <SectionTitle>Player Analysis</SectionTitle>
        <SectionContentScroll>
          <OnlinePlayerDetails />
        </SectionContentScroll>
      </Section>
    </DataWrapper>
  );
}
